window.addEventListener('DOMContentLoaded', function () {
  jQuery(function ($) {
    // Start with first category as the default filter
    let firstCategory = $('.faqs__category-button:first-of-type')
      .attr('data-category')
      .trim();

    $('.faqs__faq').each(function (idx, elem) {
      let faqElem = $(elem);
      let categories = faqElem.data('category');

      if (categories.includes(firstCategory)) {
        faqElem.addClass('matched-filter');
      }
    });

    // Filter by category on click
    $('.faqs__category-button').click(function (e) {
      e.preventDefault();

      $('.faqs__category-button').toggleClass('active', false);

      $(this).toggleClass('active', true);

      let category = $(this).attr('data-category').trim();
      $('.faqs__faq').toggleClass('matched-filter', false);

      $('.faqs__faq').each(function (idx, elem) {
        let faqElem = $(elem);
        let categories = faqElem.data('category');

        if (categories.includes(category)) {
          faqElem.addClass('matched-filter');
        }
      });
    });

    let accordions = new Accordion('.faqs__faqs-wrapper');

    var instance = new Swiper('.faqs__categories.swiper', {
      slidesPerView: 'auto',
      slidesPerGroupAuto: true,
    });
    $('.faqs__category-button');
  });
});
